import { useMutation } from '@tanstack/react-query'
import { queryClient } from 'src/'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export function useAddBookmark() {
  const fetchRequest = useFetch()

  return useMutation({
    mutationFn: ({ documentId }: { documentId: string }) =>
      fetchRequest(
        `${apiBase()}/files/${documentId}/bookmark`,
        undefined,
        {},
        'POST',
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          typeof query.queryKey[0] === 'string' &&
          query.queryKey[0].startsWith('/files'),
      })
    },
  })
}
